import styled from '@emotion/styled'

import colors from '../config/colors';

export default styled('div')`
  width: 1px;
  height: ${props => (props.size === 'small' ? 25 : 60)}px;
  margin: 0 5px;
  background-color: ${colors.blueGray};
`;
